
export const translations = {
    en: {
      // Navigation
      nav_dashboard: "Dashboard",
      nav_events: "Events",
      nav_ops: "Personal & Ops",
      nav_ai: "AI Assistant",
      nav_settings: "Settings",
      admin_user: "Admin User",
      owner: "Owner",
      
      // Systems
      sys_finance: "Finance System",
      sys_crm: "CRM & Leads",
  
      // Dashboard
      dash_title: "Financial Dashboard",
      dash_subtitle: "Overview of business health",
      btn_income: "Record Income",
      btn_expense: "Record Expense",
      smart_insight: "Smart Daily Insight",
      kpi_gross: "Gross Profit (Events)",
      kpi_net: "Net Business Profit",
      kpi_burn: "Operational Burn",
      kpi_cash: "Cash on Hand",
      table_title: "All Events Financial Overview",
      table_subtitle: "Simple breakdown of money for each event",
      col_event: "Event Details",
      col_bill: "Total Bill",
      col_in: "Collected (In)",
      col_out: "Spent (Out)",
      col_profit: "Profit",
      col_status: "Status",
      chart_cashflow: "Cash Flow",
      chart_expense: "Total Expense Distribution",
      recent_tx: "Recent Transactions",
      
      // Events
      evt_directory: "Events Directory",
      evt_new: "New Event",
      evt_filter_all: "All",
      evt_filter_up: "Upcoming",
      evt_filter_comp: "Completed",
      evt_filter_canc: "Cancelled",
      evt_customer: "Customer Name",
      evt_phone: "Phone Number",
      evt_date: "Event Date",
      evt_type: "Event Type",
      evt_loc: "Location",
      evt_guests: "Guest Count",
      evt_package: "Package",
      evt_price: "Price Per Plate",
      evt_est_total: "Estimated Total",
      evt_create_btn: "Create Event",
      evt_edit_btn: "Edit Details",
      evt_save_btn: "Save Changes",
      evt_cancel_btn: "Cancel",
      
      // Ops
      ops_title: "Personal & Operations",
      ops_subtitle: "Manage business overheads, salaries, and investments",
      ops_burn: "Ops Burn",
      ops_invest: "Investments",
      ops_outflow: "Total Outflow",
      ops_breakdown: "Monthly Breakdown",
      ops_log: "Expense Log",
      ops_add: "Add Expense",
  
      // CRM
      crm_title: "Lead Management",
      crm_subtitle: "AI-Qualified Leads from Website Chat",
      crm_hot: "HOT Leads",
      crm_warm: "WARM Leads",
      crm_cold: "COLD Leads",
      crm_score: "Score",
      crm_source: "Source",
      crm_summary: "Summary",
      crm_reason: "AI Reason",
      crm_chat: "Chat History",
      
      // AI Control
      ai_ctrl_title: "AI Control Center",
      ai_ctrl_subtitle: "Manage the Brain of your Chatbot",
      ai_provider: "Active Brain",
      ai_commands: "System Commands",
      ai_cmd_desc: "These instructions are injected into every chat to control behavior.",
      ai_email_auto: "Gmail Automation",
      ai_email_desc: "Auto-send email to admin when a lead is marked HOT.",
      
      // Knowledge Base
      kb_title: "Knowledge Base",
      kb_subtitle: "Train the AI Brain with your business data",
      kb_add: "Add Document",
      kb_name: "Document Name",
      kb_content: "Content / Text",
      kb_status: "Indexing Status",
  
      // Common
      date: "Date",
      amount: "Amount",
      category: "Category",
      mode: "Mode",
      desc: "Description",
      paid_by: "Paid By",
      status: "Status",
      actions: "Actions",
      delete: "Delete",
      edit: "Edit",
      confirm: "Confirm",
      password: "Password",
      
      // AI
      ai_title: "Finance AI Assistant",
      ai_subtitle: "Powered by Groq",
      ai_placeholder: "Ask about profit, unpaid balances, or expense trends...",
      ai_welcome: "Hello! I am your CaterMax Finance Assistant. Ask me about your profits, expenses, or event details."
    },
    kn: {
      // Navigation
      nav_dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
      nav_events: "ಕಾರ್ಯಕ್ರಮಗಳು",
      nav_ops: "ವೈಯಕ್ತಿಕ & ನಿರ್ವಹಣೆ",
      nav_ai: "AI ಸಹಾಯ",
      nav_settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
      admin_user: "ನಿರ್ವಾಹಕರು",
      owner: "ಮಾಲೀಕರು",
      
      // Systems
      sys_finance: "ಹಣಕಾಸು ವ್ಯವಸ್ಥೆ",
      sys_crm: "CRM ಮತ್ತು ಲೀಡ್ಸ್",
  
      // Dashboard
      dash_title: "ಹಣಕಾಸು ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
      dash_subtitle: "ವ್ಯಾಪಾರದ ಆರ್ಥಿಕ ಸ್ಥಿತಿ",
      btn_income: "ಆದಾಯ ಸೇರಿಸಿ",
      btn_expense: "ಖರ್ಚು ಸೇರಿಸಿ",
      smart_insight: "ದೈನಂದಿನ AI ವರದಿ",
      kpi_gross: "ಒಟ್ಟು ಲಾಭ (ಕಾರ್ಯಕ್ರಮಗಳು)",
      kpi_net: "ನಿವ್ವಳ ಲಾಭ",
      kpi_burn: "ನಿರ್ವಹಣಾ ವೆಚ್ಚ",
      kpi_cash: "ಕೈಯಲ್ಲಿರುವ ಹಣ",
      table_title: "ಎಲ್ಲಾ ಕಾರ್ಯಕ್ರಮಗಳ ವರದಿ",
      table_subtitle: "ಪ್ರತಿ ಕಾರ್ಯಕ್ರಮದ ಹಣಕಾಸಿನ ವಿವರ",
      col_event: "ವಿವರಗಳು",
      col_bill: "ಒಟ್ಟು ಬಿಲ್",
      col_in: "ಸ್ವೀಕರಿಸಿದ್ದು (ಜಮೆ)",
      col_out: "ಖರ್ಚಾಗಿದ್ದು",
      col_profit: "ಲಾಭ",
      col_status: "ಸ್ಥಿತಿ",
      chart_cashflow: "ಹಣಕಾಸಿನ ಹರಿವು",
      chart_expense: "ಖರ್ಚಿನ ವಿತರಣೆ",
      recent_tx: "ಇತ್ತೀಚಿನ ವಹಿವಾಟುಗಳು",
  
      // Events
      evt_directory: "ಕಾರ್ಯಕ್ರಮಗಳ ಪಟ್ಟಿ",
      evt_new: "ಹೊಸ ಕಾರ್ಯಕ್ರಮ",
      evt_filter_all: "ಎಲ್ಲಾ",
      evt_filter_up: "ಮುಂಬರುವ",
      evt_filter_comp: "ಮುಗಿದ",
      evt_filter_canc: "ರದ್ದುಗೊಂಡ",
      evt_customer: "ಗ್ರಾಹಕರ ಹೆಸರು",
      evt_phone: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
      evt_date: "ದಿನಾಂಕ",
      evt_type: "ವಿಧ",
      evt_loc: "ಸ್ಥಳ",
      evt_guests: "ಅತಿಥಿಗಳು",
      evt_package: "ಪ್ಯಾಕೇಜ್",
      evt_price: "ಪ್ಲೇಟ್ ಬೆಲೆ",
      evt_est_total: "ಅಂದಾಜು ಮೊತ್ತ",
      evt_create_btn: "ಕಾರ್ಯಕ್ರಮ ರಚಿಸಿ",
      evt_edit_btn: "ವಿವರ ಬದಲಿಸಿ",
      evt_save_btn: "ಉಳಿಸಿ",
      evt_cancel_btn: "ರದ್ದುಮಾಡಿ",
  
      // Ops
      ops_title: "ವೈಯಕ್ತಿಕ ಮತ್ತು ನಿರ್ವಹಣೆ",
      ops_subtitle: "ವ್ಯಾಪಾರ ವೆಚ್ಚಗಳು ಮತ್ತು ಸಂಬಳ ನಿರ್ವಹಣೆ",
      ops_burn: "ನಿರ್ವಹಣಾ ಖರ್ಚು",
      ops_invest: "ಹೂಡಿಕೆಗಳು",
      ops_outflow: "ಒಟ್ಟು ಹೊರಹರಿವು",
      ops_breakdown: "ಮಾಸಿಕ ವಿವರ",
      ops_log: "ಖರ್ಚಿನ ಪಟ್ಟಿ",
      ops_add: "ಖರ್ಚು ಸೇರಿಸಿ",
  
      // CRM
      crm_title: "ಲೀಡ್ ನಿರ್ವಹಣೆ",
      crm_subtitle: "ವೆಬ್‌ಸೈಟ್ ಚಾಟ್‌ನಿಂದ ಗ್ರಾಹಕರು",
      crm_hot: "ಉತ್ತಮ ಲೀಡ್‌ಗಳು (HOT)",
      crm_warm: "ಸಾಧಾರಣ ಲೀಡ್‌ಗಳು (WARM)",
      crm_cold: "ಕಡಿಮೆ ಆಸಕ್ತಿ (COLD)",
      crm_score: "ಅಂಕ",
      crm_source: "ಮೂಲ",
      crm_summary: "ಸಾರಾಂಶ",
      crm_reason: "AI ಕಾರಣ",
      crm_chat: "ಚಾಟ್ ಇತಿಹಾಸ",
      
      // AI Control
      ai_ctrl_title: "AI ನಿಯಂತ್ರಣ ಕೇಂದ್ರ",
      ai_ctrl_subtitle: "ಚಾಟ್‌ಬಾಟ್ ಬುದ್ಧಿವಂತಿಕೆಯನ್ನು ನಿರ್ವಹಿಸಿ",
      ai_provider: "ಸಕ್ರಿಯ AI",
      ai_commands: "ಸಿಸ್ಟಮ್ ಆದೇಶಗಳು",
      ai_cmd_desc: "ಚಾಟ್ ನಡವಳಿಕೆಯನ್ನು ನಿಯಂತ್ರಿಸಲು ಈ ಸೂಚನೆಗಳನ್ನು ಬಳಸಲಾಗುತ್ತದೆ.",
      ai_email_auto: "ಜಿಮೇಲ್ ಸ್ವಯಂಚಾಲಿತ",
      ai_email_desc: "HOT ಲೀಡ್ ಬಂದಾಗ ಅಡ್ಮಿನ್‌ಗೆ ಇಮೇಲ್ ಕಳುಹಿಸಿ.",
      
      // Knowledge Base
      kb_title: "ಜ್ಞಾನ ಕೋಶ (Knowledge Base)",
      kb_subtitle: "ನಿಮ್ಮ ವ್ಯಾಪಾರದ ಮಾಹಿತಿಯೊಂದಿಗೆ AI ಅನ್ನು ತರಬೇತಿ ಮಾಡಿ",
      kb_add: "ದಾಖಲೆ ಸೇರಿಸಿ",
      kb_name: "ದಾಖಲೆಯ ಹೆಸರು",
      kb_content: "ವಿಷಯ / ಪಠ್ಯ",
      kb_status: "ಸ್ಥಿತಿ",
  
      // Common
      date: "ದಿನಾಂಕ",
      amount: "ಮೊತ್ತ",
      category: "ವರ್ಗ",
      mode: "ವಿಧಾನ",
      desc: "ವಿವರಣೆ",
      paid_by: "ಪಾವತಿಸಿದವರು",
      status: "ಸ್ಥಿತಿ",
      actions: "ಕ್ರಿಯೆಗಳು",
      delete: "ಅಳಿಸಿ",
      edit: "ತಿದ್ದು",
      confirm: "ಖಚಿತಪಡಿಸಿ",
      password: "ಪಾಸ್‌ವರ್ಡ್",
      
      // AI
      ai_title: "ಆರ್ಥಿಕ AI ಸಹಾಯಕ",
      ai_subtitle: "Groq ನಿಂದ ಚಾಲಿತವಾಗಿದೆ",
      ai_placeholder: "ಲಾಭ, ಬಾಕಿ ಅಥವಾ ಖರ್ಚಿನ ಬಗ್ಗೆ ಕೇಳಿ...",
      ai_welcome: "ನಮಸ್ಕಾರ! ನಾನು ನಿಮ್ಮ CaterMax ಸಹಾಯಕ. ನಿಮ್ಮ ಲಾಭ, ಖರ್ಚು ಅಥವಾ ಕಾರ್ಯಕ್ರಮದ ವಿವರಗಳ ಬಗ್ಗೆ ನನ್ನನ್ನು ಕೇಳಿ."
    }
  };
